// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"8911d426","250":"2a1dbf09","407":"57bb6347","424":"62fe17e5","436":"378f5239","453":"f394a27d","455":"2b9dbaca","501":"9dd8b314","595":"3974a98b","606":"2166b220","691":"8fec22f5","821":"3918314e","925":"f68b21e8","969":"e4334dcb"}[chunkId] + ".chunk.js";
};